import { AppEnv } from "@autumn/shared";
import { LogOut, Shield } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import {
	DropdownMenuItem,
	DropdownMenuSeparator,
} from "@/components/v2/dropdowns/DropdownMenu";
import { authClient, useSession } from "@/lib/auth-client";
import { useEnv } from "@/utils/envUtils";
import { getBackendErr, notNullish } from "@/utils/genUtils";
import { AdminOnly } from "@/views/admin/components/AdminOnly";

export const AdminDropdownItems = () => {
	const { data, isPending } = useSession();
	const env = useEnv();

	const [stopImpersonatingLoading, setStopImpersonatingLoading] =
		useState(false);
	const isImpersonating = notNullish(data?.session?.impersonatedBy);
	const adminPath = env === AppEnv.Sandbox ? "/sandbox/admin" : "/admin";

	if (isPending) return null;
	return (
		<AdminOnly>
			{isImpersonating && (
				<DropdownMenuItem
					onClick={async (e) => {
						e.preventDefault();
						setStopImpersonatingLoading(true);
						try {
							await authClient.admin.stopImpersonating();
							window.location.reload();
						} catch (error) {
							toast.error(getBackendErr(error, "Failed to stop impersonation"));
						}
						setStopImpersonatingLoading(false);
					}}
					shimmer={stopImpersonatingLoading}
				>
					<div className="flex justify-between w-full items-center gap-2 text-muted-foreground">
						<span>End Impersonation</span>
						<LogOut size={12} />
					</div>
				</DropdownMenuItem>
			)}
			<DropdownMenuItem
				onClick={() => {
					window.location.href = adminPath;
				}}
			>
				<div className="flex justify-between w-full items-center gap-2 text-muted-foreground">
					Admin
					<Shield size={12} />
				</div>
			</DropdownMenuItem>
			<DropdownMenuSeparator />
		</AdminOnly>
	);
};
